import React from 'react'

const FaqPage = () => (
  <div className='faq'>
    <h2>よくあるご質問</h2>
    <ul className="breadcrumb">
      <li itemScope="itemscope" itemType="http://data-vocabulary.org/Breadcrumb">
        <a href="/" itemProp="url">
          <span itemProp="title"><i className="fas fa-home"></i> ホーム</span>
        </a>
      </li>
      <li itemScope="itemscope" itemType="http://data-vocabulary.org/Breadcrumb">
        <span itemProp="title"> <i className="fas fa-caret-right"></i> FAQ</span>
      </li>
    </ul>
    <div className='faq-item'>
      <div className='faq-question'>Q</div>
      <div className='faq-question'>
      敷金・礼金・更新料は必要ですか？
      </div>
    </div>
    <div className='faq-item'>
      <div className='faq-answer'>A</div>
      <div className='faq-answer'>
      敷金・礼金・更新料は必要ありません。但し、退去時に経年劣化ではない瑕疵、破損等による修理費や原状回復のためのクリーニング費用をご請求することがございます。
      </div>
    </div>
    <div className='faq-item'>
      <div className='faq-question'>Q</div>
      <div className='faq-question'>
      電気代、ガス、水道、無線インターネット利用料金はどのようにご請求されますか？
      </div>
    </div>
    <div className='faq-item'>
      <div className='faq-answer'>A</div>
      <div className='faq-answer'>
      安全性を考慮して、ガス設備はなく、代わりにIH調理器を装備しております。その他の料金に関しては、管理費の中に含まれます。想定の利用量を超える状況が続く場合は、管理費の見直しをする可能性もありますので、予めご了承下さい。
      </div>
    </div>
    <div className='faq-item'>
      <div className='faq-question'>Q</div>
      <div className='faq-question'>
      ペットは飼えますか？
      </div>
    </div>
    <div className='faq-row'>
      <div className='faq-answer'>A</div>
      <div className='faq-answer'>
      犬・猫などのペットの飼育は原則禁止となっております。その他の小動物に関しましては、他の入居者様のご意見を伺った上で、都度判断致します。
      </div>
    </div>
    <div className='faq-item'>
      <div className='faq-question'>Q</div>
      <div className='faq-question'>
      知人・友人・家族を泊めることは可能ですか？
      </div>
    </div>
    <div className='faq-item'>
      <div className='faq-answer'>A</div>
      <div className='faq-answer'>
      長期間に渡る宿泊は禁止しておりますが、数日の場合、シェアハウスのルームメイトの事前了承があれば問題ありません。但し、共同生活を送っておりますので、ルームメイトにご迷惑をかけぬようご理解下さい。
      </div>
    </div>
    <div className='faq-item'>
      <div className='faq-question'>Q</div>
      <div className='faq-question'>
      駄菓子屋で接客したら給料は支払われますか？
      </div>
    </div>
    <div className='faq-item'>
      <div className='faq-answer'>A</div>
      <div className='faq-answer'>
      接客による営業利益（売り上げから原価などの全ての経費を引いたもの）の半分をお支払い致します。
      </div>
    </div>
    <div className='faq-item'>
      <div className='faq-question'>Q</div>
      <div className='faq-question'>
      駄菓子屋の営業日、時間はどのようになっていますか？
      </div>
    </div>
    <div className='faq-item'>
      <div className='faq-answer'>A</div>
      <div className='faq-answer'>
      特に決まりはありません。営業日、営業時間は入居者様に委ねております。利益より入居者様の利便性を優先させますが、地域にコミュニティとしての駄菓子屋を作り上げるミッションもありますので、状況によっては駄菓子屋の接客を入居者様以外から募るご相談もさせて頂きます。
      </div>
    </div>
    <div className='faq-item'>
      <div className='faq-question'>Q</div>
      <div className='faq-question'>
      入居者のルールは？
      </div>
    </div>
    <div className='faq-item'>
      <div className='faq-answer'>A</div>
      <div className='faq-answer'>
      特にございません。入居者様の快適な生活を守るために、ご要望がありましたら導入を検討致します。なお、入居者様のご不満等の相談窓口は常時用意しております。
      </div>
    </div>
  </div>
)

export default FaqPage


// WEBPACK FOOTER //
// ./src/FaqPage.js